import React from 'react';
import { Circles } from '../common/loadingComponent';
import { codeListTypes } from './ratioBookSearchForm';
import { connect } from "react-redux";
import { getHostApi, apiGet, apiPost } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { PdfExportButton } from '../common/refButtons';
import { withLocalize, Translate } from 'react-localize-redux';
import NoDataComponent from '../common/noDataComponent';

import "../../css/search/search.scss";
import './ratioBook.scss';

class RatioBookCodeListResult extends React.Component {
    state = {
        isLoading: false,
        data: null
    };

    render() {
        if (isNullOrUndefined(this.props.year) || isNullOrUndefined(this.props.type))
            return (<NoDataComponent />);

        if (this.state.isLoading)
            return <Circles />

        return (
            <>
                {this.renderTitle(this.props.type, this.props.year)}
                {this.renderContent(this.props.type)}
            </>
        )
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.year !== prevProps.year || this.props.language !== prevProps.language) {
            this.getData();
        }
    }

    getData() {
        this.setState({ isLoading: true });

        apiGet(getHostApi() + `/api/ratiobook/code-list?year=${this.props.year}&type=${this.props.type}`,
            null,
            (data) => this.setState({ data: data.data, isLoading: false }),
            () => this.setState({ isLoading: false })
        );
    }

    renderTitle = (type, year) => {
        let trKey = null;
        if (type === codeListTypes.districts)
            trKey = "RatioBook.CodeList.Districts";
        else if (type === codeListTypes.legalForms)
            trKey = "RatioBook.CodeList.LegalForms";
        else if (type === codeListTypes.branches)
            trKey = "RatioBook.CodeList.Branches";

        if (trKey === null)
            return null;

        return (
            <div className="ratioBookTitle">
                <div className="print-hidden hide-on-mobile" style={{ visibility: "hidden"}}>
                    <PdfExportButton onClick={undefined} hideLabel oldIcon />
                </div>
                <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                    <h5 className="underlined-title rb-header"><Translate id="RatioBook.CodeList.Classification" />: <Translate id={trKey} /> {`(${year})`}</h5>
                </span>
                <div className="print-hidden hide-on-mobile">
                    <PdfExportButton onClick={() => this.exportToPdf(type, year)} hideLabel oldIcon />
                </div>
            </div>
        );
    }    

    exportToPdf = (type, year) => {
        apiPost(getHostApi() + `/api/ratiobook/code-list/pdf-export`, { year: year, type: type }, null);
    }

    renderContent = (type) => {
        switch (type) {
            case codeListTypes.districts: return this.renderDistricts();
            case codeListTypes.legalForms: return this.renderLegalForms();
            case codeListTypes.branches: return this.renderBranches();
            default: return null;
        }
    }

    renderDistricts = () => {
        return (
            <div>
                <table className="table table-report-section without-hover">
                    <colgroup>
                        <col width="10%" />
                        <col width="90%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><Translate id="RatioBook.CodeList.Shortcut" /></th>
                            <th><Translate id="RatioBook.CodeList.Name" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {["BL", "TA", "TC", "NI", "ZI", "BC", "PV", "KI"].map(d => <tr>
                            <td>{d}</td>
                            <td><Translate id={`RatioBook.CodeList.District.${d}`} /></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    renderLegalForms = () => {
        return (
            <div>
                <table className="table table-report-section without-hover rb-legal-form-table">
                    <colgroup>
                        <col width="10%" />
                        <col width="75%" />
                        <col width="15%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><Translate id="RatioBook.CodeList.LegalForm.Code" /></th>
                            <th><Translate id="RatioBook.CodeList.Name" /></th>
                            <th><Translate id="RatioBook.CodeList.Shortcut" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data && this.state.data.legalForms && this.state.data.legalForms.map(l => <>
                            <tr className="rb-legal-form-group">
                                <td></td>
                                <td>{l.name}</td>
                                <td><Translate id={`RatioBook.CodeList.LegalForm.${l.id}`} /></td>
                            </tr>
                            {l.items.map(i => <tr>
                                <td style={{ fontWeight: "normal" }}>{i.id}</td>
                                <td>{i.name}</td>
                                <td></td>
                            </tr>)}
                        </>)}
                    </tbody>
                </table>
            </div>
        );
    }

    renderBranches = () => {
        return (
            <div>
                <table className="table table-report-section without-hover w-100">
                    <colgroup>
                        <col width="10%" />
                        <col width="90%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><Translate id="RatioBook.CodeList.Branch.SkNace" /></th>
                            <th><Translate id="RatioBook.CodeList.Name" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data && this.state.data.okecCodes && this.state.data.okecCodes.map(o => <tr>
                            <td style={{ fontWeight: "normal" }}>{o.okec}</td>
                            <td>{o.name}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withLocalize(connect(state => ({ user: state.userContext }))(RatioBookCodeListResult));
